export default __webpack_public_path__ + "static/media/error.0aff03ef.png";